import { render, staticRenderFns } from "./partnerDash.vue?vue&type=template&id=13a1fa84&scoped=true&"
import script from "./partnerDash.vue?vue&type=script&lang=js&"
export * from "./partnerDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1fa84",
  null
  
)

export default component.exports